import { FEATURES } from './features'

/**
 * Lo que la web dice cuando una acción que ALCANZA a un cliente real todavía no se puede hacer
 * porque la app no está publicada en las tiendas.
 *
 * Es UN texto para las cinco operaciones (invitar o reenviar, abrir cuenta, conceder acceso,
 * liberar acceso y enviar un aviso), igual que el servidor contesta UN código para todas
 * (`CLIENT_APP_NOT_LAUNCHED`): la persona no necesita saber cuál de las cinco topó con la
 * pared, sólo que es cuestión de fecha y no de permisos.
 */
const CLIENT_APP_NOT_LAUNCHED_HINT = 'Disponible cuando la app esté publicada'

/**
 * Por qué una acción hacia el cliente no se puede usar todavía, o `null` si ya se puede.
 *
 * Es una función y no un `if (!FEATURES.clientAppLaunched)` suelto por tres razones:
 *
 * 1. Son ocho controles repartidos en siete componentes, y todos tienen que decir lo mismo.
 * 2. El runner de la web corre en `node` sin jsdom, así que una regla escrita dentro de un
 *    componente no tiene dónde tener casos. Acá se prueban las dos caras del flag.
 * 3. El motivo viaja como TEXTO y no como booleano porque se muestra: un botón apagado sin
 *    explicación deja a alguien adivinando si le falta un permiso.
 *
 * `launched` es parámetro sólo para que los tests puedan mirar las dos caras sin rebuildear: en
 * la app siempre es el valor horneado.
 *
 * ☠️ Esto NO es la guarda: es la explicación. El que frena es el servidor
 * (`409 CLIENT_APP_NOT_LAUNCHED`), porque un flag `VITE_*` protege lo que el usuario VE, no lo
 * que el servidor ATIENDE. Si web y API discrepan, la mutación falla y el mensaje sale por
 * `ERROR_MESSAGES`.
 */
export function clientAppLaunchBlockedReason(
  launched: boolean = FEATURES.clientAppLaunched
): string | null {
  return launched ? null : CLIENT_APP_NOT_LAUNCHED_HINT
}
